import React from 'react';

import { Route, Switch, Redirect } from "react-router-dom";

import Home from '../pages/Home';
import Catalog from '../pages/Catalog';
import Detail from '../pages/detail/Detail';
import Bookmarks from '../components/bookmarks/Bookmarks';
import { useSelector } from 'react-redux';
import { selectUser } from '../features/user/userSlice';
import Login from '../components/login/Login';
import Register from '../components/register/Register';

const Routes = () => {

    const user = useSelector(selectUser)
    return (
      <Switch>
        <Route path="/bookmarks" >
          {!user.displayName ? <Redirect to="/login" /> : <Bookmarks/>}
        </Route>
        <Route path="/login" >
          {!user.displayName ? <Login/> :<Redirect to="/" />}
        </Route>
        <Route path="/register" >
          {!user.displayName ? <Register/> :<Redirect to="/" />}
        </Route>
        
        <Route path="/:category/search/:keyword" component={Catalog} />
        <Route path="/:category/:id" component={Detail} />
        <Route path="/:category" component={Catalog} />
        <Route path="/" exact component={Home} />
      </Switch>
    );
}

export default Routes;
